/**
 * useTheme — 從 <html data-theme> 取得目前 theme，並在 ThemeSwitcher 變更時 re-render。
 *
 * pages 用來決定 hero emblem / motif / chrome 細節（不需要 prop drilling）。
 * 不寫值，只讀；要切 theme 還是走 ThemeSwitcher / applyPersonaTheme。
 */

import { useEffect, useState } from 'react';
import type { Theme } from './personas';

const THEMES: Theme[] = ['minimal', 'mystic', 'morandi'];

function readDocTheme(): Theme {
  if (typeof document === 'undefined') return 'minimal';
  const t = document.documentElement.getAttribute('data-theme') as Theme | null;
  return t && THEMES.includes(t) ? t : 'minimal';
}

export function useTheme(): Theme {
  const [theme, setTheme] = useState<Theme>(readDocTheme);

  useEffect(() => {
    const html = document.documentElement;
    const observer = new MutationObserver(() => {
      const next = readDocTheme();
      setTheme((cur) => (cur === next ? cur : next));
    });
    observer.observe(html, { attributes: true, attributeFilter: ['data-theme'] });
    // sync once on mount in case it changed before observer attached
    setTheme(readDocTheme());
    return () => observer.disconnect();
  }, []);

  return theme;
}
